import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class AccountingReportService {

  constructor(private apiClient: ApiClientService) {
  }

  getAdvertiserReport(params: any): Observable<any> {
    return new Observable<any>(subscriber => {
      this.apiClient.get('/accounting-report/advertiser', params).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getAffiliateReport(params: any): Observable<any> {
    return new Observable<any>(subscriber => {
      this.apiClient.get('/accounting-report/affiliate', params).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
